import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal, { SectionLabel } from "./Reveal";

const FAQS = [
  {
    q: "What is Funded Traders Club?",
    a: "Funded Traders Club is an independent review and comparison platform for proprietary trading firms. We verify payout records, score trading conditions and publish unfiltered trader reviews — so you can choose a firm with data instead of marketing.",
  },
  {
    q: "Is Funded Traders Club a prop firm?",
    a: "No. We are not a proprietary trading firm and we never hold client funds or offer trading accounts. We review, rank and compare the firms that do.",
  },
  {
    q: "How do the discount codes work?",
    a: "Tap any discount badge to copy the code, then hit Get Offer to visit the firm's site. Paste the code at checkout and the partner discount is applied to your evaluation fee.",
  },
  {
    q: "Is Funded Traders Club free to use?",
    a: "Yes — every rating, review and comparison on the platform is completely free. We are funded by referral partnerships, which never influence our editorial scores.",
  },
  {
    q: "How do you rank prop firms?",
    a: "Five weighted signals: payout reliability (30%), trading conditions (25%), value for money (20%), trader support (15%) and longevity (10%). Visitor ratings are displayed separately and never inflate the editorial score.",
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section id="faq" className="mx-auto max-w-3xl px-5 py-24 lg:px-8" data-testid="faq-section">
      <Reveal>
        <div className="text-center">
          <SectionLabel>Answers On Record</SectionLabel>
          <h2 className="mt-3 font-display text-4xl font-800 tracking-tight text-white sm:text-5xl">
            Frequently asked questions
          </h2>
        </div>
      </Reveal>
      <div className="mt-12 space-y-3">
        {FAQS.map((f, i) => (
          <Reveal key={i} delay={i * 0.05}>
            <div className="card-violet overflow-hidden" data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                data-testid={`faq-toggle-${i}`}
                className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
              >
                <span className="font-display text-base font-700 text-white sm:text-lg">{f.q}</span>
                <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-line text-muted transition-all duration-300 ${openIdx === i ? "rotate-180 border-signal/60 text-signal" : ""}`}>
                  <ChevronDown size={15} />
                </span>
              </button>
              <AnimatePresence initial={false}>
                {openIdx === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  >
                    <p className="px-6 pb-6 text-sm leading-relaxed text-muted">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15}>
        <div className="mt-10 text-center">
          <Link
            to="/blog"
            data-testid="faq-read-more"
            className="btn-beam btn-gradient-blue inline-flex items-center gap-2 px-8 py-3.5 font-display text-sm font-800 text-white"
          >
            Read More <ArrowRight size={15} />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
